// Vuex connections module actions

import { API } from '@/config';

import {
  FILL_ELEMENTS_LIST,
  FILL_LIVE_LIST,
  FILL_WIRETAPPING_UUID,
} from './mutations-types';

export default {
  async getLiveList({ commit }) {
    try {
      const result = (await API.get('/dashboard/getLiveList')).data.data;
      commit(FILL_LIVE_LIST, result);
    } catch (err) {
      console.log(err);
    }
  },
  async toggleVipStatus(context, data) {
    try {
      await API.patch('/dashboard/toggleVipStatus', data);
    } catch (err) {
      console.log(err);
    }
  },
  async checkIfNumberExists(context, data) {
    const params = { ...data };
    try {
      const response = (await API.get('/dashboard/checkIfNumberExists', { params })).data.data;
      return response;
    } catch (err) {
      return false;
    }
  },
  async toggleWiretapping({ commit }, data) {
    const params = { ...data };
    try {
      const result = (await API.get('/dashboard/toggleWiretapping', { params })).data.data;
      commit(FILL_WIRETAPPING_UUID, result?.[0].web_spy_uuid);
    } catch (err) {
      console.log(err);
    }
  },
  async disconnectWiretapping(context, data) {
    const params = { ...data };
    try {
      await API.get('/dashboard/disconnectWiretapping', { params });
      commit(FILL_WIRETAPPING_UUID, '');
    } catch (err) {
      console.log(err);
    }
  },
  async disconnectCall(context, data) {
    try {
      await API.post('/dashboard/disconnectCall', data);
    } catch (err) {
      console.log(err);
    }
  },
  async getCurrentElementsMenu({ commit }, data) {
    try {
      const result = (await API.get('/dashboard/getCurrentElementsMenu', data)).data.data;
      commit(FILL_ELEMENTS_LIST, result);
    } catch (err) {
      console.log(err);
    }
  },
};
